<template>
  <div>
    <div class="sccm">
      <div class="sccm-title">
        <h1 class="exrecord-pageTitle">导出记录</h1>
        <Form
          :model="formItem1"
          :label-width="80"
          style="margin-bottom:30px"
          @submit.native.prevent
        >
          <Row :gutter="10">
            <Col span="4">
              <DatePicker
                type="datetime"
                confirm
                @on-clear="clearTime('start')"
                :options="startTimeOptions"
                @on-ok="searchData"
                format="yyyy-MM-dd HH:mm:ss"
                @on-change="startTimeChange"
                v-model="formItem1.startTime"
                placeholder="选择生成开始时间"
              ></DatePicker>
            </Col>
            <Col span="4">
              <DatePicker
                type="datetime"
                confirm
                @on-clear="clearTime('end')"
                :options="endTimeOptions"
                @on-ok="searchData"
                format="yyyy-MM-dd HH:mm:ss"
                @on-change="endTimeChange"
                v-model="formItem1.endTime"
                placeholder="选择生成结束时间"
              ></DatePicker>
            </Col>
          </Row>
        </Form>
        <Table stripe :columns="columns" :data="tableData"></Table>
        <div class="sccm-page">
          <Page
            :total="total"
            :current="pageNum"
            :page-size="pageSize"
            show-elevator
            show-sizer
            show-total
            placement="top"
            @on-change="pageChange"
            @on-page-size-change="pageChangeSize"
          ></Page>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import envConst from '@/env-const'
export default {
  data() {
    return {
      startTimeOptions: {}, //开始日期设置
      endTimeOptions: {}, //结束日期设置
      formItem1: {
        startTime: '', //开始时间
        endTime: '' //结束时间
      },
      pageSize: 10,
      pageNum: 1,
      total: 0,
      columns: [
        {
          title: '生成时间',
          key: 'startTime',
          width: 200,
          align: 'left'
        },
        {
          title: '文件名',
          key: 'fileName',
          align: 'left'
        },
        {
          title: '导出备注',
          key: 'exportDesc',
          align: 'left'
        },
        // {
        //   title: '导出状态',
        //   key: 'status',
        //   align: 'left',
        //   width: 100,
        //   render: (h, params) => {
        //     var statusName = ''
        //     if (params.row.status === '1') {
        //       statusName = '成功'
        //     } else {
        //       statusName = '失败'
        //     }
        //     return h('div', statusName)
        //   }
        // },
        {
          title: '下载',
          key: 'fileName',
          width: 120,
          render: (h, { row }) => {
            let exportId = row.exportId
            let fileName = row.downUrl
            if (row.ctype == '1') {
              exportId = row.downUrl.substring(
                row.downUrl.lastIndexOf('/') + 1,
                row.downUrl.length
              )
              fileName = row.downUrl + '/' + row.fileName
            }
            return h('div', [
              h(
                'a',
                {
                  domProps: {
                    href:
                      envConst.SCMD_API_BASE +
                      '/scmd/askExport/downloadFileByFileName?fileName=' +
                      fileName +
                      '&exportId=' +
                      exportId
                  },
                  style: {
                    marginRight: '20px',
                    cursor: 'pointer'
                  },
                  class: '',
                  on: {
                    click: () => {}
                  }
                },
                '下载'
              )
            ])
          }
        }
      ],
      tableData: []
    }
  },
  computed: {},
  methods: {
    clearTime(item) {
      if (item == 'start') {
        this.formItem1.startTime = ''
        this.searchData()
      }
      if (item == 'end') {
        this.formItem1.endTime = ''
        this.searchData()
      }
    },
    startTimeChange(e) {
      if (e != '') {
        this.formItem1.startTime = e
        this.endTimeOptions = {
          disabledDate: date => {
            let startTime = this.formItem1.startTime
              ? new Date(this.formItem1.startTime).valueOf()
              : ''
            if (e != '') {
              return date && date.valueOf() < startTime
            } else {
              return false
            }
          }
        }
      }
    }, //设置开始时间
    endTimeChange(e) {
      this.formItem1.endTime = e
      let endTime = this.formItem1.endTime
        ? new Date(this.formItem1.endTime).valueOf()
        : ''
      this.startTimeOptions = {
        disabledDate(date) {
          if (e != '') {
            return date && date.valueOf() > endTime
          } else {
            return false
          }
        }
      }
    },
    searchData() {
      let getObj = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        startTime: this.formItem1.startTime,
        endTime: this.formItem1.endTime
      }
      this.$http
        .get(
          envConst.SCMD_API_BASE +
            '/scmd/askExport/getAskFieldRelateExportPageInfo?',
          { params: getObj }
        )
        .then(response => {
          if (response.data.returnCode === 0) {
            this.total = response.data.bean.total
            this.tableData = response.data.beans
          } else {
            this.$Message.error('查询失败')
          }
        })
    },
    pageChange(pageNum) {
      this.pageNum = pageNum
      this.searchData()
    },
    pageChangeSize(pageSize) {
      this.pageSize = pageSize
      this.searchData()
    },
    restForm() {
      //重置按钮
      this.formItem1 = {
        startTime: '', //开始时间
        endTime: '' //结束时间
      }
      this.searchData()
    }
  },
  created() {},
  mounted() {
    this.searchData()
  },
  beforeDestroy() {},
  watch: {}
}
</script>
<style scoped>
.sccm {
  padding: 24px;
  background-color: #fff;
  border-radius: 4px;
}
.sccm-page {
  text-align: center;
  margin: 16px 0 10px 0;
}
.exrecord-pageTitle {
  color: #33344a;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.exrecord-pageTitle:before {
  content: '';
  display: inline-block;
  width: 4px;
  height: 18px;
  background: #04cbd8;
  margin-right: 8px;
}
</style>